import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { COMPANY, SITE_URL, SUPPORT_EMAIL, USES_NON_ESSENTIAL_COOKIES } from '../data/launch';
export function CookiePolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-446" data-mp="3cqi0g7evmmv6">
      <SEO title="Cookie Policy | KittyPot" description="Which cookies and similar technologies kittypot.com uses, why they are used, and how to manage them." ogTitle="KittyPot Cookie Policy" ogDescription="Which cookies and similar technologies kittypot.com uses." path="/cookie-policy" data-id="element-447" data-mp="37sov1gledwvy" />
      <Navbar data-id="element-448" data-mp="3vhr9kfkqj9m8" />
      <main className="pt-32 pb-24" data-id="element-449" data-mp="3vf54qnp8b87p">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-450" data-mp="3rgp9jwizutj7">
          <h1 className="text-4xl font-black text-kitty-dark mb-4" data-id="element-451" data-mp="3re33607uak2k">
            Cookie Policy
          </h1>
          <p className="text-gray-500 font-medium mb-10" data-id="element-452" data-mp="21x985iqqjw4q">
            Last updated: 26 August 2026
          </p>

          <div className="prose prose-gray max-w-none text-gray-600 space-y-6" data-id="element-453" data-mp="26vsuhk98r9xm">
            <p data-id="element-454" data-mp="2bvf8hvww8u7h">
              This policy explains the cookies and similar technologies used on{' '}
              {SITE_URL}, operated by {COMPANY.legalName}. It covers this
              website only. How the KittyPot app handles your data is explained
              in our{' '}
              <Link to="/privacy-policy" className="font-semibold text-kitty-dark underline underline-offset-2 hover:text-kitty-yellow-700" data-id="element-455" data-mp="2ku0kf87v1aza">
                Privacy Policy
              </Link>
              .
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-456" data-mp="2zmkm04fd3aem">
              1. What cookies and local storage are
            </h2>
            <p data-id="element-457" data-mp="2evykq6tx86ss">
              A cookie is a small text file a website can place on your device.
              Local storage works in a similar way, letting a site remember
              small pieces of information in your browser. Both are used to make
              a website work properly and, in some cases, to understand how it
              is used.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-458" data-mp="2jtqjnkszgt6h">
              2. Strictly necessary technologies
            </h2>
            <p data-id="element-459" data-mp="2snv85xkn9siu">
              We use a small amount of strictly necessary browser storage to run
              this website, for example to remember a choice you have made
              about this notice. These are required for the site to function,
              they do not track you across other websites, and they cannot be
              switched off through a consent banner. Where a preference is
              stored, it stays in your browser until you clear it.
            </p>
            <p data-id="element-460" data-mp="3juve96fuvn0j">
              This website does not load fonts or tracking scripts from third
              parties. Images are served from a content delivery network, which
              receives your IP address as a normal part of sending the image to
              your browser. Where a form on this site submits your details, they
              are sent through Google infrastructure as described in our Privacy
              Policy. Neither sets a tracking cookie on this site.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-461" data-mp="355z7rdtg6i21">
              3. Analytics technologies
            </h2>
            {USES_NON_ESSENTIAL_COOKIES ? <p data-id="element-462" data-mp="2r8ascli5g34d">
                We use analytics to understand how this website is used in
                aggregate, such as which pages are visited. These are
                non-essential, so they are only used if you accept them in our
                cookie notice, and you can change your mind at any time.
              </p> : <p data-id="element-463" data-mp="2qhatx3t57zfd">
                We do not currently run analytics cookies on this website. If we
                introduce them, we will update this policy and ask for your
                consent before they are used.
              </p>}

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-464" data-mp="2hi7ce49mjs2z">
              4. Marketing technologies
            </h2>
            <p data-id="element-465" data-mp="27iqazz1eo0ct">
              We do not use advertising or cross-site tracking cookies on this
              website. We do not sell your browsing data, and we do not run
              targeted advertising from this site.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-466" data-mp="1xswv4lu8cz2r">
              5. Managing your preferences
            </h2>
            <p data-id="element-467" data-mp="1orpb98sgo0s7">
              {USES_NON_ESSENTIAL_COOKIES ? 'You can accept or reject non-essential technologies using the notice shown when you first visit. You can also block or delete cookies and clear local storage in your browser settings.' : 'Because we only use strictly necessary storage, there is nothing to consent to at the moment. You can still block or delete cookies and clear local storage in your browser settings at any time.'}{' '}
              Blocking storage may stop parts of the website working as
              intended.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-468" data-mp="d8056vto4xjw">
              6. Changes to this policy
            </h2>
            <p data-id="element-469" data-mp="3hnrlz71trpob">
              If we add new technologies to this website we will update this
              policy and the date at the top of the page.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-470" data-mp="3qguv535ftgd5">
              7. Contact us
            </h2>
            <p data-id="element-471" data-mp="2tzi58jjgxs41">
              If you have any questions about this Cookie Policy, email{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-kitty-dark underline underline-offset-2 hover:text-kitty-yellow-700" data-id="element-472" data-mp="2y0btje0tp8xg">
                {SUPPORT_EMAIL}
              </a>{' '}
              or write to us:
            </p>
            <address className="not-italic" data-id="element-473" data-mp="evmzx9o93v7c">
              {COMPANY.addressLines.map(line => <React.Fragment key={line} data-id="element-474" data-mp="9x219eondjl0">
                  {line}
                  <br data-id="element-475" data-mp="9ywk8ngcz1mg" />
                </React.Fragment>)}
            </address>
          </div>
        </div>
      </main>
      <Footer data-id="element-476" data-mp="3de21xug7yryq" />
    </div>;
}